"use client";

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from "@/contexts/analytics-context";
import { AS202_BANNER_VARIANTS, getCtvExperimentAssignment, isCtvQaUserId } from "@/lib/ctv-dmas";
import { getCookie } from "@/utilities/cookie";
const getAs202QaUserId = () => {
  if (typeof window === "undefined") {
    return "";
  }
  const cookieUserId = getCookie("iw-uid");
  const userId = typeof cookieUserId === "string" ? cookieUserId : "";
  return isCtvQaUserId(userId) ? userId : "";
};
export const useAs202Decision = () => {
  const $ = _c(14);
  const {
    optimizelyDecisionsRan,
    getOptimizelyDecisionInfo,
    optimizelyUser
  } = useAnalytics();
  let dma;
  let dmaGroup;
  let t0;
  let variationKeyAs202;
  if ($[0] !== getOptimizelyDecisionInfo || $[1] !== optimizelyDecisionsRan || $[2] !== optimizelyUser.attributes.dma || $[3] !== optimizelyUser.attributes.dmaGroup) {
    const qaUserId = getAs202QaUserId();
    dma = String(optimizelyUser.attributes.dma ?? "");
    dmaGroup = String(optimizelyUser.attributes.dmaGroup ?? "");
    const assignment = getCtvExperimentAssignment(qaUserId);
    const decidedVariation = getOptimizelyDecisionInfo("AS202");
    variationKeyAs202 = "";
    if (assignment.flagKey === "AS202") {
      if (qaUserId && assignment.variationKey) {
        variationKeyAs202 = assignment.variationKey;
      } else {
        if (!decidedVariation || decidedVariation === "control") {
          variationKeyAs202 = "control";
        } else {
          variationKeyAs202 = decidedVariation;
        }
      }
    }
    t0 = optimizelyDecisionsRan && (AS202_BANNER_VARIANTS as readonly string[]).includes(variationKeyAs202);
    $[0] = getOptimizelyDecisionInfo;
    $[1] = optimizelyDecisionsRan;
    $[2] = optimizelyUser.attributes.dma;
    $[3] = optimizelyUser.attributes.dmaGroup;
    $[4] = dma;
    $[5] = dmaGroup;
    $[6] = t0;
    $[7] = variationKeyAs202;
  } else {
    dma = $[4];
    dmaGroup = $[5];
    t0 = $[6];
    variationKeyAs202 = $[7];
  }
  const shouldRunAs202 = t0;
  let t1;
  if ($[8] !== dma || $[9] !== dmaGroup || $[10] !== optimizelyDecisionsRan || $[11] !== shouldRunAs202 || $[12] !== variationKeyAs202) {
    t1 = {
      isDecisionReadyForAs202: optimizelyDecisionsRan,
      shouldRunAs202,
      variationKeyAs202,
      dma,
      dmaGroup
    };
    $[8] = dma;
    $[9] = dmaGroup;
    $[10] = optimizelyDecisionsRan;
    $[11] = shouldRunAs202;
    $[12] = variationKeyAs202;
    $[13] = t1;
  } else {
    t1 = $[13];
  }
  return t1;
};